import { defineSlotRecipe } from '@chakra-ui/react';

export const featuredCountryItemSlotRecipe = defineSlotRecipe({
    slots: ['links'],
    base: {
        links: {
            zIndex: 2,
            flexWrap: 'wrap',
            alignItems: 'center',
            mt: 3,
            columnGap: 3,
            rowGap: 2,
            fontSize: 'sm',
            maxWidth: '272px',
        },
    },
});
